import React from 'react';
import { cn } from '../../utils/cn';
import Icon from '../AppIcon';

const defaultPanelClassName =
  'bg-card rounded-xl max-w-lg w-full max-h-[90vh] overflow-hidden shadow-elevation-xl border border-border flex flex-col';

const backdropPaddingClass = {
  none: '',
  x: 'px-4',
  all: 'p-4'
};

/**
 * Centered modal overlay + panel. Open/close is controlled by the parent (e.g. return null when closed).
 *
 * @param {'none'|'x'|'all'} [backdropPadding='x'] — `none`: full-bleed (legacy legal/payment); `x`: horizontal gutters; `all`: padding on all sides (blur overlays).
 */
export function ModalShell({
  children,
  backdropClassName = 'bg-slate-900/40 backdrop-blur-sm',
  zClass = 'z-50',
  panelClassName,
  backdropPadding = 'x'
}) {
  const pad =
    typeof backdropPadding === 'string'
      ? backdropPaddingClass[backdropPadding] ?? backdropPaddingClass.x
      : backdropPaddingClass.x;

  return (
    <div
      className={cn(
        'fixed inset-0 flex items-center justify-center',
        pad,
        zClass,
        backdropClassName
      )}
    >
      <div className={cn(panelClassName ?? defaultPanelClassName)}>{children}</div>
    </div>
  );
}

export function ModalHeader({
  title,
  onClose,
  titleClassName,
  className,
  closeButtonClassName
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-between px-5 py-4 border-b border-border flex-shrink-0 bg-muted/30',
        className
      )}
    >
      <h2 className={cn('text-lg font-semibold text-foreground tracking-tight', titleClassName)}>
        {title}
      </h2>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className={
            closeButtonClassName ??
            'p-1.5 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth'
          }
          aria-label="Fechar"
        >
          <Icon name="X" size={20} />
        </button>
      )}
    </div>
  );
}
